<template>
  <dropdown class="marketing-sms-list-item-actions"
            :data-border="false"
            dataMenuWidth="115px"
            data-icon="mdi-dots-vertical"
            @hidden="hideEveryModal">

    <p v-if="!hideEdit"
       class="marketing-sms-list-item-actions-item pointer"
       @click.stop="editSmsItem">
      {{$t('message.generics.message.edit')}}
    </p>

    <p v-if="!isDraft"
       class="marketing-sms-list-item-actions-item pointer"
       @click="goToViewPage">
        {{$t('message.generics.message.view')}}
    </p>

    <p class="marketing-sms-list-item-actions-item pointer"
       @click="showDuplicateModal">
        {{$t('message.generics.message.duplicate')}}
    </p>

    <p v-if="!hideDelete"
       class="marketing-sms-list-item-actions-item pointer"
       @click.stop="showDeleteModal">
        {{$t('message.generics.message.delete')}}
    </p>

    <p v-if="isPartiallySent"
       class="marketing-sms-list-item-actions-item pointer"
       @click="resend">
        Continuar envio
    </p>

    <confirmation-modal :value="showCreditDeleteModal"
                        confirm-label="Confirmar"
                        @confirm="deleteSms"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        {{$t('message.marketingGenerics.message.deleteMessage')}}
      </span>
      <span>
        {{$t('message.marketingGenerics.message.deleteMessageConfirmation')}}
      </span>
    </confirmation-modal>

    <marketing-create-modal-type v-model="showingDuplicateModal"
                                 :item="item"
                                 duplicate
                                 @duplicate="duplicateSms" />

    <marketing-sms-create-modal-automation v-model="showingAutomationModal"
                                           :item="item"
                                           :title="item.title"
                                           @edited="emitEdited" />

  </dropdown>
</template>

<script>
import MarketingSmsCreateModalAutomation from "@components/modules/marketing/sms/generic/create/modal/automation/MarketingSmsCreateModalAutomation";
import MarketingCreateModalType from "@components/modules/marketing/generic/create/modal/type/MarketingCreateModalType";
import ConfirmationModal from "@components/ConfirmationModal";
import Dropdown from "@components/Dropdown";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Dropdown,
    ConfirmationModal,
    MarketingCreateModalType,
    MarketingSmsCreateModalAutomation,
  },
  data() {
    return {
      showCreditDeleteModal: false,
      showingDuplicateModal: false,
      showingAutomationModal: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isAutomation: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hideEdit() {
      return (
        this.item.status === "SENT" ||
        this.item.status === "PARTIALLY_SENT_BY_CREDIT" ||
        this.item.status === "PARTIALLY_SENT_BY_SYSTEM" ||
        this.item.status === "SENDING"
      );
    },
    hideDelete() {
      return (
        this.item.status === "SENT" ||
        this.item.status === "PARTIALLY_SENT_BY_CREDIT" ||
        this.item.status === "PARTIALLY_SENT_BY_SYSTEM" ||
        this.item.status === "SENDING"
      );
    },
    isDraft() {
      return this.item.status === "DRAFT";
    },
    isPartiallySent() {
      return (this.item.status === "PARTIALLY_SENT_BY_CREDIT" || this.item.status === "PARTIALLY_SENT_BY_SYSTEM")
    }
  },
  methods: {
    hideEveryModal() {
      this.closeDeleteModal();
      this.closeDuplicateModal();
      this.closeAutomationEditModal();
    },
    showDuplicateModal() {
      this.showingDuplicateModal = true;
    },
    closeDuplicateModal() {
      this.showingDuplicateModal = false;
    },
    showDeleteModal() {
      this.showCreditDeleteModal = true;
    },
    closeDeleteModal() {
      this.showCreditDeleteModal = false;
    },
    showAutomationEditModal() {
      this.showingAutomationModal = true;
    },
    closeAutomationEditModal() {
      this.showingAutomationModal = false;
    },
    async deleteSms() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.marketing.sms.message.delete({
          smsId: this.item.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.draftDeleted'),
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        //empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    goToEditPage() {
      this.$router.push({ path: `/marketing/editar-envio/${this.item.id}` });
    },
    goToViewPage() {
      this.$router.push({ path: `/marketing/vizualizar/${this.item.id}` });
    },
    async duplicateSms({ isAutomationFlow }) {
      await this.$api.marketing.sms.message.duplicate({
        isAutomation: isAutomationFlow,
        smsId: this.item.id,
      });

      this.$emit("duplicated");
    },
    editSmsItem() {
      if (this.isAutomation) {
        this.showAutomationEditModal();
      } else {
        this.goToEditPage();
      }
    },
    emitEdited() {
      this.$emit("edited");
    },
    async resend() {
      return new Promise(async (resolve, reject) => {
        try {
          await this.$api.marketing.sms.message.resend({
            smsId: this.item.id
          })
          this.$emit("resent");
          resolve(
          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: "Envio retomado com sucesso!",
          }));
        } catch (error) {
          reject(error)          
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.marketing-sms-list-item-actions {
  .marketing-sms-list-item-actions-item {
    margin-bottom: 0px;
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 5px;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: none;
      transform: translateY(1px);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
